const INPUT_SELECTOR = '.multi-toggle';

const MultiToggleInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function () {
            const multiToggle = $(this);
            const btns = multiToggle.find('.options label');
            const boxes = multiToggle.find('.options input[type="checkbox"]');

            if (multiToggle.attr('data-single')) {
                btns.on('click', function (e) {
                    e.preventDefault();

                    const btn = $(this);
                    const box = $(`#${btn.attr('for')}`);

                    boxes.each(function () {
                        $(this).prop('checked', false);
                    });

                    box.prop('checked', true);
                });
            }
        });
    },
};

export default MultiToggleInput;
